import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import QRCode from 'qrcode.react';
import styles from './AIGCInit.module.less';

import { CONTEXT, APP_VERSION_D } from '../../config';
import { logging } from '../../actions/log';
import { aigcShowDialog, aigcShowInit } from '../../actions/aigc';
import { addClass, removeClass, changeClass, logNative, localGetItem } from '../../utils/utils';
import FirstConversation from './components/FirstConversation';
import UserQuestion from './components/UserQuestion';
import AiAnswer from './components/AiAnswer/AiAnswerIndex';
import { PCStoreJsBridge } from '../../nativeapi';
import { cacheKeys, GUI_MODE_INFO } from '../../constants/storageKeys';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectAIGC = createSelector(
  state => state.aigc,
  aigc => aigc,
);

let WpPayTimeoutIndex = 0;
export default memo(() => {
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const AIGCObj = useSelector(selectAIGC); //
  const [payWayList, setPayWayList] = useState([]);

  const AIGC_box = useRef(null);
  const aigcNode = useRef(null);
  const aigcDescNode = useRef(null);

  /*AIGC AB对照组接入*/
  useEffect(() => {
    const machineInfoStr = localStorage.getItem(cacheKeys.LOCALMACHINE_INFO);

    if (!machineInfoStr) {
      PCStoreJsBridge.getLocalMachineInfo().then(res => {
        aigcDetermine(res);
      });
    } else {
      const machineInfo = JSON.parse(machineInfoStr);
      aigcDetermine(machineInfo);
    }
  }, []);

  useEffect(() => {
    if (AIGCObj?.showInit && logInfoData) {
      setTimeout(() => {
        dispatch(
          logging({
            category: 'I',
            action: `Search_Aigc`,
            label: '',
            param2: {
              source: `AIGC_${logInfoData.source}`,
            },
          }),
        );
      }, 1000);
    }
  }, [logInfoData, AIGCObj?.showInit]);

  const getAbtest = info => {
  
    try {
      const abTest = new ABTest();
      const config = {
        // /*****
        //  * 测试配置地址：https://abtest-admin.mbgtest.lenovomm.com/experiment/index
        //  * 测试登录账号：pengml3 123456
        //  * https://abtest-admin.mbgtest.lenovomm.com/test/detail?id=443
        //  * ****/
        // ////// 测试配置 //////
        // appId: '1163779516408960',
        // privateKey:
        //   'MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCO/3zDUxehk08WP3d5cpv7N1h4j5wyyNCOK3eWHNZOhVZKvmFtcK+bo7SkAVydD2gP4qsac6wMepkJH2FYKojgB7KpxShqPTjA9rNGkBKYMvdTK+WUHutRPfq8gbgGbo/Ci35Gh0Csyxycq8i9oyFrvMaBcyNANFI4q31zRDzDXvTC6kskAoGK/AKqnhKDd7bqUg8WbpWVksWTNk9df0wZXg7G0o0wF7dCnhm3gtlSBWrDEp1Aa0HotEwYhnADyKwxEA5SvdhV5le0m2CDrvj37VfMAFP0gyMiGcU+PMUwOyYeWnWvpWzLZsSO2qq1TR/TJEJpgBXJbU3DRqf/0JSnAgMBAAECggEAP318PZUlBt5K3Qvs1gVm8BFQvKa2qW2z+4udGw9Or6pP9/uzck34CliTGcZpAmsWvwbbBXGaUCgWzpAaPnUUNLP2RZ5+JT1td2+RhaDuQJlQaqMw2aUowfeM3imSNXjdZ3lb5aCjvJSp7X3wMRK/AgDc+hjO6/DPGM47cvQ3Ll7NAEdfJ4+7bZFTKgRdTCBgeYH9r+rN2q7fngqVlSoVTv4Wzs0Q3EgkFp6oeypZHzlG/6qh63lQu7IFI3whz7rnPETE6dAxv27xnzXazpnIra8ITC6v9X8RXSdeIquggrNsBy8TI/nubl4TpOXPIcFcxT5I3nYcppsbjixCIy9/YQKBgQDdfAQUEgBR7GwoH9LQc0vhDNl3FdPGbdRWwVLWIuABNfyWyXZXw57mlzPZw6WozmrMZq/ZBugCN+i54mAPJjkGOg3Td4rWTPx9tQNrB8uNWdg+trIyvw7OEpfp9kGfWTvMIXRUOK5SOzEFuCFmNrDJDyWmQOqi3N64lk3GJ/JQbwKBgQClSE28VQFVLL8J9+i8pe5iykmjTLOsiAnu9h3J/tpAaMd0iHkWEusmFw8cqDr43NQMjfTHg51t7FmdLZHS8I7mmejmNzuQNiDdMxDOXVrHRzuG9S8x+dTETHhO7/yrElkwVWDJnh+2CVEWzwoIF6LhQZDdU5Q+HO4Auhvpm5srSQKBgEt+0VkSBb/nCbrnlhFtq4iru5im/QffOgjUXusU+iwPfejcBRXHXWuWUJtC4D3ZFnhT7E7a1syiyBZMfpfLXJatxTa2wcFofoxO3jpmbtDgtiAyYC2CCIbfuZ6LTTUG0qYzJRbsNydae8xKRkA0FjCClD/GUvRuuxBKU3pe9W7LAoGAQNjybu7nG/T3a0DSFpn/wtDdPW3NnOavBwuXOnZ8SQMTJnyZDXkUu5gWfMbghF2X8OkNXe4cqVEvA8UqTpnFZ2KBhzmqa/VgxYjQkjb8c+1VxKiUAMalnPLnzQjJmJEVXypQVCpvBKv5HbrTk8M6S6i+3qd5JTmSg8SBSRGdOskCgYEAoyaSipupYZOX0m+6roi0Jde8B6ZOC8kvctgr4MfYmZs9am9hS8dP/k70G6qSSSnJSIx5GxqJzlVDmMMnOY2LPWVrpLr5ndyzecAtxrV5o/BlPWeLEvwBOTFmTF1zCPS1vpctemiApPNiRVwiBR3AkfNcZUkrV8IgKjAREnEzbIA=',
        // experimentId: 443,
        // ////// 测试配置 //////

        ////// 线上配置 //////
        appId: 1194044974248576,
        privateKey:
          'MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCMHoShbi225GxKMTDMt0218GeO0KIZAL0AvoiVJKv4QdiADnV7JFh9mIWaTdfekUYD3xUwvY3oPKGHi0JOIrERiMQFPax2+NFSR3C7DMlKW3s1IQR+0CBx3rQptX3jwVQ5fpiy3H+5Hfn3K6fOf6GA41LtxSyFNz57gogxHn0QBxt801FhSAV/wpBI4ehUO4UlPcRaAqSuxm3WY90WULUSKgGtAgkulAOI3I5at4rC2n4pqoXum9XVj/AkiRSkIKLcPwLVyDLwSWRF4LCYLw51dPbZxvxzNPj5vX60CXuNUEY5G7q9/oRMicSefVQ7PbsZIce5WRYChZaoLG+IAdmFAgMBAAECggEAO4+VbVF6WS4L4hW62qpofBguzQRegyZPMQvM3yjxeNv0faqnwaqXevvkfszsIA28p1Sim09YDQoI16cYjkIs5nkuadPnhcMKp2D6yGgNAHCWlOTuFkG+KOkzyC7/zlqVxMLNgeo82KGnaavC7wJN0o3O6IdR/2aWRsYbwlVlb/QURwCmuHmm4YOK06xtuXEGaC2UndD965aDtwByLNwwaGV4Qu+/22fx3d5UwAe/bNbPwi0zzKdTViXxgrtJa0uhoRI04FvYgL5NXpoGkQSdO/g0SMQhyIihqKVqtSOF5WI4bhSc/4Cw0oK0f1GD8GLR/HZKKshpoDfu44IrjcAW2QKBgQDGj9XtGUvBDW2BPYspBpICU6l74/63ZtHPZdZuNppcultSF6AeUtBVYfgT9O5jIs65eawVYETzgZvp1K4MTcdBN6CHmipElUvw+tjiRNhiLuEhEvQv+g7+0Hkh0GmYiS+DWr0dIGZEqxKn7wSodrmfY+2c9ubJzynjMzokG46mGwKBgQC0ps+AiaGqSrjHmCDUPPeavKoEnI891J+yQa9LbWRdCuk8xERbWGASvdGBYNZWZOaCPRR+ngGbIgGEllmNOtzt4toC3TdU/w0gZVYW5PGkRocKfzJrUO5z5DUh9hMrElDAEoBB8MMfo+6xxmh8Z/PsE4WZJuHHywZuVr17cs/43wKBgQCwhTJzY+eaqmtNV/8c68Bl3SZxA1FwjjG7pRcqR9SW1v1UT7iC/LBFF6FJbJd4/nq1HNvE7R6fM/v9tps8SPD4o5FMu9sTuX4Xr4mcLgQH1RFDK+x1smIeWgs16mfVuS/KIKK7ABCqv0MIlE6ZzWJbtqSIxF6LzmW4m9P2QaFhPQKBgQCjrVvml0zt0SPYW+Kqyc6B2Zyl7v/twp8q0E62JZhAoOkwUJeqt8jcUjXnZkjtICCmMhdGnXzRBR+g9OSQjJutwdNLswk2LpzDFG3K8oZqFCi4fwS8rShPwp3NdnpplP+q91hT5oO0QEC9vAnhZgJgjFOIruz0q+PYxyiJGD6MuwKBgBQao4BJRTKMT+ThlJNoSDzso47LtNn//4s2JrONNLrsaP/i0sJWBWP/n9Qj3e2cFPXKeeWNbDSWvvYwCRUjvLlf68OEzqwtBE4T+X5T0ljJNoDukQxmrfCEklqYmQ4zfZfXDC6OPYNyRNU1N3oh7noyRjAR4T5qH46X3XjTkK0N',
        experimentId: 5,
        ////// 线上配置 //////
        deviceId: info?.ludp_uuid ?? new Date().getTime(),
        options: {
          variableValue: '1',
        },
      };
      abTest.init(config).catch(error => {
        logNative(`中台 abtest 调用失败 ${error}`);
      });
      abTest.onNotify(data => {
        logNative(`中台 abtest 收到通知，数据发生变化 ${JSON.stringify(data)}`);
        if (data?.variableValue === '1') {
          dispatch(aigcShowInit(true));
        } else {
          dispatch(aigcShowInit(false));
        }
      });
    } catch (error) {}
  };

  const aigcDetermine = info => {
    if (APP_VERSION_D === '9.0.1149.0926' && +new Date('2023-11-30 23:59:59') - +new Date() > 0) {
      dispatch(aigcShowInit(true));
    } else {
      getAbtest(info);
    }
  };

  const handleAigcIn = () => {
    addClass(aigcNode.current, styles.aigc_moveIn);
    removeClass(aigcNode.current, styles.aigc_moveOut);
  };

  const handleAigcOut = () => {
    addClass(aigcNode.current, styles.aigc_moveOut);
    removeClass(aigcNode.current, styles.aigc_moveIn);
    removeClass(aigcDescNode.current, styles.aigc_desc_show);
  };

  const handleAnimation = e => {
    if (e?.target?.className.indexOf(styles.aigc_moveIn) > -1) {
      addClass(aigcDescNode.current, styles.aigc_desc_show);
    }
  };

  let modelInfo = {};
  try {
    modelInfo = JSON.parse(localGetItem(GUI_MODE_INFO) || '{}');
  } catch (e) {}

  return (
    <>
      {AIGCObj?.showInit && modelInfo?.businessCode !== 'SMB' && (
        <div
          className={styles.top_aigc}
          onClick={() => {
            dispatch(
              aigcShowDialog({
                show: true,
                text: logInfoData?.search_word,
              }),
            );
            dispatch(
              logging({
                category: 'C',
                action: `Search_Aigc`,
                label: '',
                param2: {
                  source: `AIGC_${logInfoData.source}`,
                },
              }),
            );
          }}
          ref={aigcNode}
          onMouseEnter={handleAigcIn}
          onMouseLeave={handleAigcOut}
          onAnimationEnd={e => handleAnimation(e)}
        >
          <div className={styles.aigc_icon} />
          <div className={styles.aigc_desc} ref={aigcDescNode}>
            试试AI搜索
          </div>
        </div>
      )}
    </>
  );
});
